import { type OpenApiSchemaMediaItemV2 } from '../../../api/schema';
import { type MediaV2Field } from './createMediaV2Field';
import { mapMediaMetadataToFileMetadata } from './mediaMetadata';

export function mapMediaV2FieldToMediaItemV2(field: MediaV2Field): OpenApiSchemaMediaItemV2 {
    if (field.type !== 'VIDEO') {
        const { metadata, ...payload } = field;

        return {
            type: field.type,
            display_sequence: field.display_sequence,
            payload: {
                ...payload,
                file_metadata: mapMediaMetadataToFileMetadata(metadata),
            },
        };
    }

    return {
        type: field.type,
        display_sequence: field.display_sequence,
        payload: field,
    };
}
